import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { PurchaseVirtualDetailResponse, PurchaseVirtualResponse } from 'src/app/models/purchase.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';
import { PurchasesService } from 'src/app/services/purchases.service';

@Component({
  selector: 'app-purchase-pending-receipt-details',
  templateUrl: './purchase-pending-receipt-details.component.html',
  styleUrls: ['./purchase-pending-receipt-details.component.scss']
})
export class PurchasePendingReceiptDetailsComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  @Input() purchaseVId: number;
  @Input() purchaseV: PurchaseVirtualResponse;
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  details: PurchaseVirtualDetailResponse[] = [];
  totalPurchase = 0;

  constructor(private purchaseService: PurchasesService, private toastService: ToastrService){}

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    if (!this.purchaseVId) {
      return;
    }
    this.purchaseService.getDetailPurchasesPendingReceipt(this.purchaseVId).subscribe({
      next: (response: ResponseObject) => {
        this.details = response.data
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los detalles de la compra", "Error");
      }
    });
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(true);
  }

  get total(){
    return (this.purchaseV.totalCost + this.purchaseV.totalTaxes + this.purchaseV.extraTax).toFixed(2);
  }

  subtotal(quantity: number, price: number){
    return (quantity * price).toFixed(2);
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }
  

}
